import { Routes } from '@angular/router';
import { titleFormatter } from '@core/utils/general.utils';

export const seasonRoutes: Routes = [
  {
    path: 'seasons',
    title: titleFormatter('Seasons'),
    data: { title: 'Seasons' },
    loadComponent: () => import('./pages/Home/Home.component').then((m) => m.SeasonsHomeComponent),
  },
];
